import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-pdf',
  templateUrl: './pdf.component.html',
  styleUrls: ['./pdf.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PdfComponent implements OnInit {

  @Input() pdfUri: string;
  isEdgeOrIE11: boolean;

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.isEdgeOrIE11 = /Edge/.test(navigator.userAgent) || /Trident.*rv[ :]*11\./.test(navigator.userAgent);
  }

  getSafeUrl(uri): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(uri);
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/shared/pdf/pdf.component.ts